var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseConfirmModal',{attrs:{"show":_vm.show,"subject":"cloneTask","title":_vm.title,"ok-text":_vm.okText,"cancel-text":_vm.cancelText},on:{"close":function($event){return _vm.$emit('close')},"confirm":_vm.submitForm}}),_c('blocking-loader',{attrs:{"show":_vm.loading}},[_vm._v(" "+_vm._s(_vm.loaderMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }